
;(function () {
  const AW_TRACK_URL = 'https://jwiuxklfllcsqpooabpt.supabase.co/functions/v1/track-event'
  const AW_TRACK_IS_EU = location.hostname.startsWith('eu.')

  // Theme editor previews would pollute the numbers.
  if (window.Shopify && window.Shopify.designMode) return

  const pageStartedAt = Date.now()
  const awOrigFetch = window.fetch
  const referrerHost = (() => {
    try { return document.referrer ? new URL(document.referrer).hostname : null } catch { return null }
  })()

  // ── CONSENT ────────────────────────────────────────────────────
  // true = allowed, false = declined, null = not answered yet
  function awReadConsentCookie() {
    const raw = document.cookie.split('; ').find((c) => c.startsWith('_tracking_consent='))
    if (!raw) return null
    try {
      const c = JSON.parse(decodeURIComponent(raw.slice('_tracking_consent='.length)))
      // v2.x: explicit banner choice, '1' / '0' / '' (unanswered)
      const cmpAnalytics = c && c.con && c.con.CMP && c.con.CMP.a
      if (cmpAnalytics === '1') return true
      if (cmpAnalytics === '0') return false
      // v2.x: Shopify's effective permission for this region. It reads false
      // while an EU banner is still unanswered, so only trust a false once
      // there's no pending banner choice.
      if (c && c.purposes && c.purposes.a === true) return true
      if (cmpAnalytics === '') return null
      if (c && c.purposes && c.purposes.a === false) return false
      // v1.x
      if (c && c.con && c.con.GDPR === '1') return true
      if (c && c.con && c.con.GDPR === '0') return false
    } catch { /* malformed cookie → treat as unanswered */ }
    return null
  }

  // Shopify's Customer Privacy API comes first: with Shopify's newer cookie
  // storage, consent sits in an HttpOnly cookie (_shopify_essential) that
  // page scripts can't read, so _tracking_consent is only a fallback for
  // stores still on the old storage.
  function awReadConsent() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      try {
        const a = (privacy.currentVisitorConsent() || {}).analytics
        if (a === 'yes') return true
        if (a === 'no') return false
      } catch { /* fall through */ }
    }
    const fromCookie = awReadConsentCookie()
    if (fromCookie !== null) return fromCookie
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      try { if (privacy.analyticsProcessingAllowed()) return true } catch { /* fall through */ }
    }
    return null
  }

  let awConsent = AW_TRACK_IS_EU ? awReadConsent() : true
  const awQueue = []

  // Anything short of a clear yes holds events in memory instead of dropping
  // them, so a "not allowed yet" cookie that flips to accepted a moment later
  // still gets this visit's page_view. Nothing leaves the browser until then.
  function awSetConsent(value) {
    if (value === null || value === awConsent) return
    awConsent = value
    if (awConsent) awQueue.splice(0).forEach((e) => awSend(e.event, e.meta))
  }

  if (AW_TRACK_IS_EU) {
    // Make sure the privacy API is loaded (the banner loads it too, but not
    // necessarily before this runs), then read the saved choice.
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
          if (!err) awSetConsent(awReadConsent())
        })
      }
    } catch { /* never let analytics break the page */ }
    // Shopify fires this when the visitor answers the cookie banner.
    document.addEventListener('visitorConsentCollected', (e) => {
      const d = e && e.detail
      if (d && typeof d.analyticsAllowed === 'boolean') awSetConsent(d.analyticsAllowed)
      else awSetConsent(awReadConsent())
    })
    // Third-party consent apps sometimes only write the cookie — re-check it
    // for a while in case no event shows up.
    let checks = 0
    const consentPoll = setInterval(() => {
      awSetConsent(awReadConsent())
      if (++checks >= 300) clearInterval(consentPoll) // ~10 min
    }, 2000)
  }

  // ── SESSION ────────────────────────────────────────────────────
  // One id per tab, so reloads don't double-count. Only written to
  // sessionStorage once tracking is actually allowed.
  let awSessionId = null
  function awGetSessionId() {
    if (awSessionId) return awSessionId
    try { awSessionId = sessionStorage.getItem('aw_sid') } catch { /* storage blocked */ }
    if (!awSessionId) {
      awSessionId = (crypto.randomUUID && crypto.randomUUID()) ||
        Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12)
    }
    try { sessionStorage.setItem('aw_sid', awSessionId) } catch { /* storage blocked */ }
    return awSessionId
  }

  // ── SEND ───────────────────────────────────────────────────────
  // text/plain keeps it a CORS "simple request" — no preflight, and it's the
  // only way sendBeacon can survive the page unloading.
  function awSend(event, meta) {
    const body = JSON.stringify({
      session_id: awGetSessionId(),
      event,
      path: location.pathname,
      referrer: referrerHost,
      meta: meta || {},
    })
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(AW_TRACK_URL, new Blob([body], { type: 'text/plain' }))) return
    } catch { /* fall through to fetch */ }
    try {
      awOrigFetch.call(window, AW_TRACK_URL, { method: 'POST', body, keepalive: true }).catch(() => {})
    } catch { /* never let analytics break the page */ }
  }

  function awTrack(event, meta) {
    if (awConsent === true) awSend(event, meta)
    else if (awQueue.length < 100) awQueue.push({ event, meta })
  }

  // ── TRAFFIC SOURCE ─────────────────────────────────────────────
  // UTM tags on this URL first; then the ones Shopify kept from the visit's
  // landing page (_shopify_sa_p), for people who landed elsewhere first; then
  // ad click ids; then the referring site.
  function awCookie(name) {
    const raw = document.cookie.split('; ').find((c) => c.startsWith(name + '='))
    return raw ? raw.slice(name.length + 1) : null
  }
  function awTrafficSource() {
    const params = new URLSearchParams(location.search)
    let source = params.get('utm_source'), medium = params.get('utm_medium'), campaign = params.get('utm_campaign')
    if (!source) {
      try {
        const sa = awCookie('_shopify_sa_p')
        if (sa) {
          const kept = new URLSearchParams(decodeURIComponent(sa))
          source = kept.get('utm_source'); medium = medium || kept.get('utm_medium'); campaign = campaign || kept.get('utm_campaign')
        }
      } catch { /* malformed cookie */ }
    }
    if (!source) {
      const clickIds = [['gclid', 'google', 'cpc'], ['gbraid', 'google', 'cpc'], ['wbraid', 'google', 'cpc'],
        ['msclkid', 'bing', 'cpc'], ['ttclid', 'tiktok', 'cpc'], ['fbclid', 'facebook', 'social'], ['epik', 'pinterest', 'social']]
      const hit = clickIds.find(([param]) => params.has(param))
      if (hit) { source = hit[1]; medium = medium || hit[2] }
    }
    if (!source && referrerHost) {
      const host = referrerHost.replace(/^(www|m|l|lm|mobile)\./, '')
      if (/(^|\.)oceansilhouettes\.com$|\.myshopify\.com$/.test(host)) { source = '(your store)'; medium = medium || 'internal' }
      else if (/(^|\.)(google|bing|duckduckgo|yahoo|ecosia|yandex)\./.test(host)) { source = host.match(/(google|bing|duckduckgo|yahoo|ecosia|yandex)/)[1]; medium = medium || 'organic' }
      else if (/(^|\.)(facebook|instagram|pinterest|tiktok|reddit|youtube|x|t)\.(com|co)$/.test(host)) { const name = host.split('.').slice(-2, -1)[0]; source = name === 't' ? 'x' : name; medium = medium || 'social' }
      else { source = host; medium = medium || 'referral' }
    }
    return {
      utm_source: (source || '(direct)').slice(0, 100),
      utm_medium: (medium || '(none)').slice(0, 100),
      utm_campaign: campaign ? campaign.slice(0, 100) : undefined,
    }
  }

  // ── 1. ENTERED ─────────────────────────────────────────────────
  awTrack('page_view', awTrafficSource())
  // Coming back via the back button restores the page from bfcache without
  // re-running scripts — count it, so an earlier exit isn't read as the end.
  window.addEventListener('pageshow', (e) => { if (e.persisted) awTrack('page_view', { restored: true }) })

  // ── PAGE LOAD ──────────────────────────────────────────────────
  // page_loaded carries the browser's own Navigation Timing numbers, all in ms
  // from the moment the page was requested: fully loaded (load_ms), HTML
  // parsed (dom_ms), first byte back from Shopify (ttfb_ms).
  let awLoaded = document.readyState === 'complete'
  function awReportLoad() {
    awLoaded = true
    // loadEventEnd is only filled in once every load handler has finished.
    setTimeout(() => {
      const meta = {}
      try {
        const nav = performance.getEntriesByType('navigation')[0]
        if (nav && nav.loadEventEnd > 0) {
          meta.load_ms = nav.loadEventEnd
          meta.dom_ms = nav.domContentLoadedEventEnd
          meta.ttfb_ms = nav.responseStart
        }
      } catch { /* older browser */ }
      if (meta.load_ms == null) meta.load_ms = performance.now()
      awMeasureScroll()
      awTrack('page_loaded', meta)
    }, 0)
  }
  if (awLoaded) awReportLoad()
  else window.addEventListener('load', awReportLoad, { once: true })

  // ── TIME ON SCREEN ─────────────────────────────────────────────
  // Only counts while the tab is actually showing (from the moment the page
  // was requested), so a tab left open in the background doesn't inflate it.
  let awVisibleMs = 0
  let awVisibleSince = document.visibilityState === 'visible' ? 0 : null
  document.addEventListener('visibilitychange', () => {
    const now = performance.now()
    if (document.visibilityState === 'visible') { if (awVisibleSince === null) awVisibleSince = now }
    else if (awVisibleSince !== null) { awVisibleMs += now - awVisibleSince; awVisibleSince = null }
  })
  const awVisibleTotal = () => awVisibleMs + (awVisibleSince !== null ? performance.now() - awVisibleSince : 0)

  // ── SCROLL DEPTH ───────────────────────────────────────────────
  // Furthest point seen, as % of the page height (bottom of the screen).
  let awScrollPct = 0, awScrollQueued = false
  function awMeasureScroll() {
    try {
      const doc = document.documentElement
      const height = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0)
      const seen = (window.scrollY || doc.scrollTop || 0) + window.innerHeight
      if (height > 0) awScrollPct = Math.max(awScrollPct, Math.min(100, Math.round((100 * seen) / height)))
    } catch { /* ignore */ }
  }
  window.addEventListener('scroll', () => {
    if (awScrollQueued) return
    awScrollQueued = true
    requestAnimationFrame(() => { awScrollQueued = false; awMeasureScroll() })
  }, { passive: true })

  // ── 3. UPLOADED ────────────────────────────────────────────────
  // ai-print.js un-hides #awPreviewArea only after a photo passes its
  // resize + size checks, so that's the real "upload accepted" moment.
  function awWatchUpload() {
    const preview = document.getElementById('awPreviewArea')
    if (!preview) return
    let wasHidden = preview.classList.contains('aw-hidden')
    new MutationObserver(() => {
      const hidden = preview.classList.contains('aw-hidden')
      if (wasHidden && !hidden) awTrack('upload')
      wasHidden = hidden
    }).observe(preview, { attributes: true, attributeFilter: ['class'] })
  }

  // ── READ THE PAGE ──────────────────────────────────────────────
  // read_help = scrolled far enough that the "How it works / FAQ" section
  // reached the upper 70% of the screen, i.e. they were reading, not just landing.
  function awWatchHelp() {
    const help = document.querySelector('.aw-help')
    if (!help || !('IntersectionObserver' in window)) return
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { io.disconnect(); awTrack('read_help') }
    }, { rootMargin: '0px 0px -30% 0px' })
    io.observe(help)
  }

  function awWatchPage() { awWatchUpload(); awWatchHelp() }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', awWatchPage)
  else awWatchPage()

  // ── GENERATE, PREVIEW + 4. FORWARDED ───────────────────────────
  // Watch the widget's own calls instead of editing ai-print.js:
  //   generate-preview ok      → generate (with the job id, which links purchases)
  //   generate-preview refused → generate_failed, stage "rejected"
  //   poll-status finished     → preview (portrait shown) or generate_failed, stage "render"
  //   collect-email handle     → forward; ai-print.js redirects to /products/<handle>
  let awForwarded = false, awLastJobId = null, awGenStartedAt = 0
  const awFinishedJobs = new Set()
  window.fetch = function (input, init) {
    const promise = awOrigFetch.apply(window, arguments)
    try {
      const url = input instanceof Request ? input.url : String(input)
      if (url.includes('/functions/v1/generate-preview')) {
        awGenStartedAt = Date.now()
        promise
          .then((res) => res.clone().json().catch(() => ({})).then((data) => {
            if (res.ok && data && data.job_id) {
              awLastJobId = data.job_id
              awTrack('generate', { job_id: data.job_id })
            } else if (!res.ok) {
              awTrack('generate_failed', { stage: 'rejected', http_status: res.status })
            }
          }))
          .catch(() => {})
      } else if (url.includes('/functions/v1/poll-status')) {
        const jobId = new URL(url, location.href).searchParams.get('job_id')
        promise
          .then((res) => (res.ok ? res.clone().json() : null))
          .then((data) => {
            if (!data || !jobId || awFinishedJobs.has(jobId)) return
            const waited = awGenStartedAt ? Date.now() - awGenStartedAt : undefined
            if (data.status === 'awaiting_email' || data.status === 'done') {
              awFinishedJobs.add(jobId)
              awTrack('preview', { job_id: jobId, ms_wait: waited })
            } else if (data.status === 'failed') {
              awFinishedJobs.add(jobId)
              awTrack('generate_failed', { job_id: jobId, stage: 'render', ms_wait: waited })
            }
          })
          .catch(() => {})
      } else if (url.includes('/functions/v1/collect-email')) {
        awTrack('email_submit')
        promise
          .then((res) => (res.ok ? res.clone().json() : null))
          .then((data) => {
            if (data && data.product_handle) {
              awForwarded = true
              awTrack('forward', { product_handle: data.product_handle, job_id: awLastJobId || undefined })
            }
          })
          .catch(() => {})
      }
    } catch { /* never let analytics break the page */ }
    return promise
  }

  // ── WIDGET STEPS ───────────────────────────────────────────────
  // ai-print.js reports these itself: photo_picked (chose/dropped/pasted a
  // photo), photo_rejected (e.g. over 5 MB) and generate_click (pressed
  // Generate with verification done). "upload" above is the photo accepted.
  document.addEventListener('aw:action', (e) => {
    const d = (e && e.detail) || {}
    if (d.action === 'photo_picked') awTrack('photo_picked')
    else if (d.action === 'photo_rejected') awTrack('photo_rejected', { reason: d.reason })
    else if (d.action === 'generate_click') awTrack('generate_click')
  })

  // ── VERIFICATION (Turnstile) ───────────────────────────────────
  // ai-print.js dispatches aw:turnstile — ok (first token, ms since load),
  // error (Cloudflare error code, first few only) and timeout (no token 20s+).
  document.addEventListener('aw:turnstile', (e) => {
    const d = (e && e.detail) || {}
    if (d.status === 'ok') awTrack('turnstile_ok', { ms: d.ms })
    else if (d.status === 'error') awTrack('turnstile_error', { code: d.code })
    else if (d.status === 'timeout') awTrack('turnstile_timeout', { ms: d.ms })
  })

  // ── EMAIL STEP ─────────────────────────────────────────────────
  // email_focus = tapped into the email box (once per page view); the send
  // itself is email_submit, from the collect-email call above.
  let awEmailFocused = false
  document.addEventListener('focusin', (e) => {
    if (!awEmailFocused && e.target && e.target.id === 'awEmail') { awEmailFocused = true; awTrack('email_focus') }
  })

  // ── HOW THEY LEFT ──────────────────────────────────────────────
  // Browsers don't say why a page is closing, so the last link click (within
  // 5s of leaving) stands in: a link to another page of this store, or to
  // another site. Anything else (closed the tab, back button, typed a URL,
  // closed the Facebook/Instagram browser) counts as "left".
  const AW_STORE_HOST = /(^|\.)oceansilhouettes\.com$|\.myshopify\.com$/
  let awLastLink = null
  document.addEventListener('click', (e) => {
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return // opens a new tab
    const a = e.target && e.target.closest && e.target.closest('a[href]')
    if (!a || a.target === '_blank') return
    let url
    try { url = new URL(a.href, location.href) } catch { return }
    if (!/^https?:$/.test(url.protocol)) return
    if (url.pathname === location.pathname && url.search === location.search) return // same-page anchor
    awLastLink = { at: Date.now(), leave: AW_STORE_HOST.test(url.hostname) ? 'internal' : 'external' }
  }, true)
  // Forms here (search, add to cart) all submit to the store itself.
  document.addEventListener('submit', () => { awLastLink = { at: Date.now(), leave: 'internal' } }, true)

  // ── 2. LEFT ────────────────────────────────────────────────────
  // pagehide (not visibilitychange) = actually leaving, not just switching
  // tabs. The product-page redirect also fires this, hence meta.forwarded;
  // the stats never count forwarded sessions as bounces.
  window.addEventListener('pagehide', () => {
    awMeasureScroll()
    const viaLink = awLastLink && Date.now() - awLastLink.at < 5000 ? awLastLink.leave : null
    awTrack('exit', {
      ms: Date.now() - pageStartedAt,
      forwarded: awForwarded,
      loaded: awLoaded,
      visible_ms: Math.round(awVisibleTotal()),
      scroll_pct: awScrollPct,
      leave: awForwarded ? 'internal' : viaLink || 'left',
    })
  })
})()
